import { trfq } from '@px/react-utils';

export const getHostDomain = (hostname) => {
  const hostnameParts = hostname?.split('.');
  const len = hostnameParts?.length;
  if (hostname?.endsWith('.co.uk')) {
    return hostnameParts?.splice(len - 3, 3).join('.');
  } else if (len > 2) {
    return hostnameParts?.splice(len - 2, 2).join('.');
  }
  return hostname;
};

export const isCartIconExperimentOn = async () => {
  const url = `https://cart.${getHostDomain(window.location.hostname)}/checkoutapi/v1/carticon/experiment`;
  const options = { method: 'GET', credentials: 'include' };
  options.headers = { 'content-type': 'application/json' };
  try {
    const res = await fetch(url, options);
    if (!res.ok) {
      trfq.logImpression(`gce.cart.icon.experiment-error-${res.status}.impression`);
      return false;
    }
    return await res.json();
  } catch (error) {
    trfq.logImpression('gce.cart.icon.experiment-error.impression');
    return false;
  }
};
